import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa'; // Import the left arrow icon

function ManageAmenitiesServices() {
  const tabClass =
    'px-6 py-2 text-base font-medium border-b-2 border-transparent hover:border-black transition-all ';
  const activeClass = ' text-white bg-black';

  return (
    <div className="mb-4 ">
      <NavLink
        to="/dashboard/mdm/amenities-management/amenities"
        className="flex items-center text-gray-400 hover:text-black mb-4"
      >
        <FaArrowLeft className="mr-3 text-md" /> {/* Left arrow icon */}
        <span className="text-lg">Back to Amenities</span>
      </NavLink>

      {/* Tabs container */}
      <div className="flex  ">
        <NavLink
          to="/dashboard/mdm/amenities-management/amenities/manage-amenity-category"
          className={({ isActive }) =>
            `${tabClass} ${isActive ? activeClass : 'text-black bg-white'}`
          }
        >
          Categories
        </NavLink>
        <NavLink
          to="/dashboard/mdm/amenities-management/amenities/manage-amenity-subcategory"
          className={({ isActive }) =>
            `${tabClass} ${isActive ? activeClass : 'text-black bg-white'}`
          }
        >
          Sub-categories
        </NavLink>
        <NavLink
          to="/dashboard/mdm/amenities-management/amenities/manage-amenity-items"
          className={({ isActive }) =>
            `${tabClass} ${isActive ? activeClass : 'text-black bg-white'}`
          }
        >
          Service Items
        </NavLink>
      </div>
    </div>
  );
}

export default ManageAmenitiesServices;
